module.exports = __webpack_public_path__ + "static/zmigrod_main_44-25bb41db227e944395d8447c649d7df4.png";